import { trackEvent } from '../utils';
export default function showGuideView() {
    const rootView = document.createElement('div');
    const pic1 = document.createElement('img');
    const pic2 = document.createElement('img');
    rootView.className = 'launch-app-guide-view';
    rootView.style.position = 'fixed';
    rootView.style.top = '0';
    rootView.style.left = '0';
    rootView.style.zIndex = '9999';
    rootView.style.width = '100vw';
    rootView.style.height = '100vh';
    rootView.style.textAlign = 'center';
    rootView.style.color = '#fff';
    rootView.style.backgroundColor = 'rgba(0, 0, 0, .6)';
    pic1.src = 'https://ut-static.udache.com/webx/ut/fHqLDgx0WtEo4FiWRmnFK.png';
    pic2.src = 'https://ut-static.udache.com/webx/ut/MfcLieAwgRx-n_D-JpPet.png';
    pic1.style.width = '23.2vw';
    pic1.style.height = '28.93vw';
    pic1.style.position = 'absolute';
    pic1.style.top = '4.4vw';
    pic1.style.right = '6.13vw';
    pic2.style.position = 'absolute';
    pic2.style.width = '81.6vw';
    pic2.style.height = '26.7vw';
    pic2.style.top = '35.2vw';
    pic2.style.left = '0';
    pic2.style.right = '0';
    pic2.style.margin = '0 auto';
    rootView.appendChild(pic1);
    rootView.appendChild(pic2);
    document.body.appendChild(rootView);
    // 埋点：引导浏览器打开页面曝光
    trackEvent('launch_app_user_guide_popup_expose');
    rootView.onclick = function () {
        rootView.remove();
    };
}
